import { Component, Input } from '@angular/core';
import { AlertTypeEnum } from '../../enums/alert-type.enum';

@Component({
    selector: 'app-alert-warning',
    templateUrl: './alert-warning.component.html',
    styleUrls: ['./alert-warning.component.scss']
})
export class AlertWarningComponent {
    /**
     * If true, the alert message will attempt to fit on one line,
     * instead of wrapping to multiple lines.
     */
    @Input()
    public wide = false;

    public readonly AlertTypeEnum = AlertTypeEnum;
}
